import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/ar/poi-group/poi-group.js';
      

      export interface Props {
     expand?: boolean;
     collapsing?: boolean;
     positionVertical?: string;
     internalSwapping?: boolean
   }

      
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcPoiGroup',
  props: {
    expand: { type: Boolean },
    collapsing: { type: Boolean },
    positionVertical: {},
    internalSwapping: { type: Boolean }
  },
  emits: ["expand", "collapse-finished"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onExpand: (event: CustomEvent<{expand:boolean}>) => emit('expand', event as CustomEvent<{expand:boolean}>),
onCollapseFinished: (event: CustomEvent<void>) => emit('collapse-finished', event as CustomEvent<void>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-poi-group',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})